import { render, staticRenderFns } from "./MyMarquee.vue?vue&type=template&id=0c359294&scoped=true&"
import script from "./MyMarquee.vue?vue&type=script&lang=js&"
export * from "./MyMarquee.vue?vue&type=script&lang=js&"
import style0 from "./MyMarquee.vue?vue&type=style&index=0&id=0c359294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c359294",
  null
  
)

export default component.exports